import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "private-admin-notice"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "private-admin-notice-privacy" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "🔒 管理员专属通知"),
  /*#__PURE__*/_createElementVNode("p", null, "本通知仅限您所在分店的管理员账号查看，员工、普通客户及其他角色均不可见，请放心阅读。")
], -1)
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 0,
  class: "private-admin-notice-tip"
}
const _hoisted_6 = {
  key: 1,
  class: "private-admin-notice-error",
  role: "alert"
}
const _hoisted_7 = { class: "private-admin-notice-actions" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "private-admin-notice-footer" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  key: 1,
  role: "alert"
}

import {computed,ref,watch,onBeforeUnmount,onMounted} from 'vue'
import {useRoute} from 'vue-router'
import store from '@/store'
import request from '@/utils/request'
import {adminNoticeBlocking,adminNoticeVisit} from '@/utils/adminNoticeRuntime'

export default /*#__PURE__*/_defineComponent({
  __name: 'BranchAdminNotice',
  props: {
    channel: {},
    ready: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props=__props,route=useRoute()
const eligible=ref(false),items=ref<any[]>([]),notice=ref<any>(null),expanded=ref(false),busy=ref(false),error=ref(''),inboxError=ref(''),inboxVisible=ref(false),inboxWidth=ref(420)
let serial=0,disposed=false,checking=false,attempted='',poll:ReturnType<typeof setInterval>|undefined
const orgId=computed(()=>Number(props.channel==='admin'?store.getters.userInfo?.orgId:store.getters.orgId))
const identity=computed(()=>store.getters.token && store.getters.userInfo?.id && props.ready!==false && orgId.value>1000?JSON.stringify([store.getters.token,orgId.value,store.getters.userInfo.id,store.getters.userInfo.orgId,store.getters.userInfo.roleId]):'')
const unconfirmed=computed(()=>items.value.filter(n=>!n.confirmed).length)
function safe(){return document.visibilityState!=='hidden' && !/pay|orderconfirm|upgrade|deposite|login|request|upload|edit|[/]add/i.test(route.path) && !Array.from(document.querySelectorAll('.ant-modal-wrap:not(.private-admin-notice-shell), .ant-drawer-open')).some(el=>el.getClientRects().length>0 && getComputedStyle(el).visibility!=='hidden') && !/INPUT|TEXTAREA|SELECT/.test(document.activeElement?.tagName || '')}
function resize(){inboxWidth.value=Math.min(440,window.innerWidth)}
async function api(method:'GET'|'POST',path:string,data?:any){const result=await request({url:(props.channel==='admin'?'branchAdminNotices':'customer/branchAdminNotices')+path,method,params:props.channel==='web'?{orgId:orgId.value,channel:'web'}:undefined,data});return result.data}
function reset(){serial++;notice.value=null;items.value=[];eligible.value=false;inboxVisible.value=false;inboxError.value='';error.value='';expanded.value=false;adminNoticeBlocking.value=false;attempted=''}
function dismiss(){if(busy.value)return;notice.value=null;expanded.value=false;error.value='';adminNoticeBlocking.value=false}
async function load(){const who=identity.value,ticket=serial;if(!who)return false;const response=await api('GET','/inbox');if(disposed || ticket!==serial || who!==identity.value)return false;eligible.value=response?.eligible===true;items.value=eligible.value && Array.isArray(response.items)?response.items:[];if(notice.value && !notice.value.confirmed){const current=items.value.find(n=>n.id===notice.value.id && n.version===notice.value.version);if(!current || current.confirmed){notice.value=null;expanded.value=false;adminNoticeBlocking.value=false}}if(!eligible.value){notice.value=null;inboxVisible.value=false;adminNoticeBlocking.value=false}return eligible.value}
async function check(){
 if(checking || disposed || !identity.value || !safe())return
 const who=identity.value,ticket=serial,visit=adminNoticeVisit(who);checking=true;adminNoticeBlocking.value=true
 try{
  if(!await load() || notice.value || attempted===visit || !safe())return
  attempted=visit;const value=await api('POST','/claim',{visit})
  if(disposed || ticket!==serial || who!==identity.value || !safe() || !value?.id)return
  notice.value=value;expanded.value=false;error.value='';await api('POST','/'+value.id+'/'+value.version+'/shown')
 }catch{/* 服务未启用或权限不符时保持关闭，不干扰浏览。 */}
 finally{checking=false;if(!notice.value)adminNoticeBlocking.value=false}
}
async function action(action:string){const current=notice.value,who=identity.value,ticket=serial;if(!current || busy.value)return null;busy.value=true;error.value='';try{const value=await api('POST','/'+current.id+'/'+current.version+'/'+action);if(disposed || ticket!==serial || who!==identity.value || current!==notice.value)return null;notice.value=value;return value}catch(e:any){if(ticket===serial)error.value=e?.message || '操作未成功，请稍后重试';return null}finally{busy.value=false}}
async function view(){if(await action('view'))expanded.value=true}
async function confirm(){if(await action('confirm')){notice.value=null;adminNoticeBlocking.value=false;void load()}}
async function openInbox(){inboxError.value='';try{if(await load()){inboxVisible.value=true;notice.value=null;adminNoticeBlocking.value=false}}catch{inboxError.value='通知暂时无法读取，请稍后重试'}}
async function openItem(item:any){const who=identity.value,ticket=serial;inboxError.value='';try{const value=await api('POST','/'+item.id+'/'+item.version+'/view');if(disposed || ticket!==serial || who!==identity.value)return;inboxVisible.value=false;notice.value=value;expanded.value=true;adminNoticeBlocking.value=true}catch(e:any){inboxError.value=e?.message || '通知已更新或停止展示，请刷新'}}
function visibility(){if(document.visibilityState==='hidden'){notice.value=null;adminNoticeBlocking.value=false}else if(identity.value){adminNoticeVisit(identity.value,true);attempted='';void check()}}
watch(identity,()=>{reset();if(identity.value){adminNoticeBlocking.value=true;void check()}},{immediate:true})
watch(()=>route.path,()=>{notice.value=null;inboxVisible.value=false;adminNoticeBlocking.value=false;void check()})
onMounted(()=>{resize();window.addEventListener('resize',resize);document.addEventListener('visibilitychange',visibility);poll=setInterval(()=>{if(notice.value)void load().catch(()=>{/* 保留现有浏览状态，下一轮重试。 */});else void check()},4000)})
onBeforeUnmount(()=>{disposed=true;reset();clearInterval(poll);window.removeEventListener('resize',resize);document.removeEventListener('visibilitychange',visibility)})

return (_ctx: any,_cache: any) => {
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (eligible.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "admin-notice-entry",
          onClick: openInbox
        }, [
          _createTextVNode("管理员通知"),
          (unconfirmed.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_1, " · " + _toDisplayString(unconfirmed.value), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_a_modal, {
      visible: !!notice.value,
      footer: null,
      closable: false,
      "mask-closable": false,
      width: 420,
      centered: "",
      "wrap-class-name": "private-admin-notice-shell",
      "body-style": {padding:'0',background:'transparent'},
      onCancel: dismiss
    }, {
      default: _withCtx(() => [
        (notice.value)
          ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
              _createElementVNode("small", null, "平台通知 · " + _toDisplayString(notice.value.important?'重要事项':'分店管理员专属'), 1),
              _createElementVNode("h2", null, _toDisplayString(notice.value.title), 1),
              _hoisted_3,
              _createElementVNode("div", {
                class: _normalizeClass(["private-admin-notice-body", {expanded: expanded.value}])
              }, [
                (notice.value.imageData)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: notice.value.imageData,
                      alt: "通知图片"
                    }, null, 8, _hoisted_4))
                  : _createCommentVNode("", true),
                _createElementVNode("p", null, _toDisplayString(notice.value.body), 1)
              ], 2),
              (!expanded.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_5, "点击“查看完整通知”后，可确认收到。"))
                : _createCommentVNode("", true),
              (error.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(error.value), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("button", {
                  type: "button",
                  disabled: busy.value,
                  onClick: dismiss
                }, "稍后", 8, _hoisted_8),
                (!expanded.value)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      disabled: busy.value,
                      onClick: view
                    }, "查看完整通知", 8, _hoisted_9))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  type: "button",
                  class: "primary",
                  disabled: busy.value || notice.value.confirmed || notice.value.important && !expanded.value,
                  onClick: confirm
                }, _toDisplayString(notice.value.confirmed?'已确认收到':'确认收到'), 9, _hoisted_10)
              ]),
              _createElementVNode("small", _hoisted_11, _toDisplayString(notice.value.confirmed?'已在各端同步确认状态':'确认收到后，管理端、网页客户端和小程序均不再自动弹出本条通知。'), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          type: "button",
          class: "private-admin-notice-close",
          "aria-label": "稍后处理管理员通知",
          disabled: busy.value,
          onClick: dismiss
        }, "×", 8, _hoisted_12)
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_drawer, {
      visible: inboxVisible.value && eligible.value,
      title: "管理员专属通知",
      width: inboxWidth.value,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (inboxVisible.value=false))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_alert, {
          type: "info",
          "show-icon": "",
          message: "仅分店管理员可见，员工和普通客户不可见。"
        }),
        (!items.value.length)
          ? (_openBlock(), _createBlock(_component_a_empty, {
              key: 0,
              description: "暂无管理员专属通知"
            }))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item) => {
          return (_openBlock(), _createElementBlock("button", {
            key: item.id+':'+item.version,
            class: "private-admin-notice-row",
            type: "button",
            onClick: ($event: any) => (openItem(item))
          }, [
            _createElementVNode("strong", null, _toDisplayString(item.title), 1),
            _createElementVNode("span", null, _toDisplayString(item.important?'重要 · ':'') + _toDisplayString(item.confirmed?'已确认收到':'待确认') + " 查看 ›", 1)
          ], 8, _hoisted_13))
        }), 128)),
        (inboxError.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(inboxError.value), 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible", "width"])
  ], 64))
}
}

})